import { InitCookie } from '@patsnap/init-cookie';

export class InitCookieService {
    async init() {
        const fromParam = new URLSearchParams(window.location.search).get('from') || new URLSearchParams(window.location.hash.split('?')[1] || '').get('from');
        const cookie = new InitCookie({
            entry_channel: InitCookie.getEntryChannel() || 'rd_triz',
            campaign_name: fromParam || InitCookie.getCampaignName() || 'rd_project',
        });
        return await cookie.init();
    }
}

export const initCookieService = new InitCookieService();
